<template>
  <transition name="fade-out">
    <div class="loading-part">
      <div class="loading-rects">
        <div class="rect-middle">
          <div class="rect-1">
            <div
              class="side"
              :style="{
                width:
                  loadingProgress >= 25
                    ? `55px`
                    : `${55 * (loadingProgress / 25)}px`
              }"
              :class="{ active: loadingProgress >= 25 }"
            />
            <div
              class="side"
              :style="{
                height:
                  loadingProgress >= 50
                    ? `55px`
                    : `${55 * (loadingProgress / 50)}px`
              }"
              :class="{ active: loadingProgress >= 50 }"
            />
            <div
              class="side"
              :style="{
                width:
                  loadingProgress >= 75
                    ? `55px`
                    : `${55 * (loadingProgress / 75)}px`
              }"
              :class="{ active: loadingProgress >= 75 }"
            />
            <div
              class="side"
              :style="{
                height:
                  loadingProgress >= 100
                    ? `55px`
                    : `${55 * (loadingProgress / 100)}px`
              }"
              :class="{ active: loadingProgress >= 100 }"
            />
            <img
              class="rect-center-logo"
              style="width: 100%"
              src="@/assets/images/virsody-single.logo.png"
              alt=""
            />
          </div>
          <div class="rect-2" />
          <div class="rect-3" />
          <div class="rect-4" />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
let hintTimer = null;
export default {
  props: {
    loadingProgress: {
      type: Number,
      default: 0
    },
    preload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ready: false,
      prog: 0,
      hintState: 2
    };
  },
  mounted() {
    if (!hintTimer) {
      hintTimer = setInterval(() => {
        this.hintState = this.hintState + 1 < 3 ? this.hintState + 1 : 0;
      }, 100);
    }
  },
  methods: {
    emitInitialize() {
      this.$emit('emit-init');
    }
  }
};
</script>
<style lang="scss" scoped>
.loading-part {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: linear-gradient(-45deg, #002833, #00382d, #37002e);
  background-size: 400% 400%;
  animation: gradient 5s infinite;
  pointer-events: none;

  // background-color: #000;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.logo {
  position: absolute;
  bottom: 28px;
  left: 50%;
  width: 140px;
  transform: translate(-50%, 0);
}

.loading-rects {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  width: 190px;
  height: 180px;
  transform: translate(-50%, -50%);
  flex-direction: column;

  .rect-middle {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100px;
    height: 100px;
    transform: translate(-50%, -50%) rotate(45deg);
  }

  @media screen and (max-height: 460px) {
    transform: translate(-50%, calc(-50% - 40px));
  }

  .rect-1 {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 55px;
    height: 55px;
    transform: translate(-50%, -50%);

    .rect-center-logo {
      transform: rotate(-45deg);
    }

    .prog {
      position: absolute;
      top: 50%;
      left: 50%;
      font-size: 12px;
      color: #00b6f0;
      transform: translate(-50%, -50%) rotate(-45deg);
      font-weight: bold;
      letter-spacing: 0.02em;
    }

    .side {
      position: absolute;
      background-color: #fff;
      transition: all 0.15s ease-in-out;

      &.active {
        background-color: #00b6f0;
      }

      &:nth-child(1) {
        top: 0;
        left: 0;
        width: 55px;
        height: 1px;
      }

      &:nth-child(2) {
        top: 0;
        right: 0;
        width: 1px;
        height: 55px;
      }

      &:nth-child(3) {
        right: 0;
        bottom: 0;
        width: 55px;
        height: 1px;
      }

      &:nth-child(4) {
        bottom: 0;
        left: 0;
        width: 1px;
        height: 55px;
      }
    }
  }

  .rect-2 {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 62px;
    height: 62px;
    border: 1px solid #fff;
    opacity: 0;
    transform: translate(-50%, -50%);
    -webkit-animation: fadeoutanimation-1 1s linear infinite;
    animation: fadeOutAnimation-1 1s linear infinite;
  }

  .rect-3 {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 69px;
    height: 69px;
    border: 1px solid #fff;
    opacity: 0;
    transform: translate(-50%, -50%);
    -webkit-animation: fadeoutanimation-2 1s linear infinite;
    animation: fadeOutAnimation-2 1s linear infinite;
    animation-delay: 0.1s;
  }

  .rect-4 {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 76px;
    height: 76px;
    border: 1px solid #fff;
    opacity: 0;
    transform: translate(-50%, -50%);
    -webkit-animation: fadeoutanimation-3 1s linear infinite;
    animation: fadeOutAnimation-3 1s linear infinite;
    animation-delay: 0.2s;
  }

  .loading-text {
    position: absolute;
    bottom: 4px;
    left: 50%;
    width: 100%;
    font-size: 12px;
    text-align: center;
    color: #fff;
    letter-spacing: 0.02em;
    transform: translate(-50%, 0);
  }
}

@keyframes fadeOutAnimation-1 {
  0% {
    width: 62px;
    height: 62px;
    opacity: 0;
  }

  100% {
    width: 69px;
    height: 69px;
    opacity: 1;
  }
}

@keyframes fadeOutAnimation-2 {
  0% {
    width: 69px;
    height: 69px;
    opacity: 0;
  }

  100% {
    width: 76px;
    height: 76px;
    opacity: 1;
  }
}

@keyframes fadeOutAnimation-3 {
  0% {
    width: 76px;
    height: 76px;
    opacity: 0;
  }

  100% {
    width: 83px;
    height: 83px;
    opacity: 1;
  }
}
</style>
